import React from 'react';
import { useQuery } from '@tanstack/react-query';

import type { UseQueryWrapper } from 'app/types';
import { useSnakeBar } from '../../useSnakeBar';
import type { GetConnectionByIdArgs } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

type GetConnectionByIdQueryVariables = GetConnectionByIdArgs;

export type ConnectionInspectorResult = {
  connectionId: string;
  connectionName: string;
  createdAt: string;
  latestRun: string | null;
  deleted: boolean;
  productName: string;
  salaryPackage: string;
  employerId: string;
  employerName: string;
  employerIsPensioenbijIntegration: boolean;
  ownerId: string;
  ownerName: string;
  numberOfEmployees: number;
  numberOfEvents: number;
};

const queryFn = (variables: GetConnectionByIdQueryVariables) => async () => {
  const response = await adminServices.getConnectionById(variables);
  return response.data;
};

const QUERY_KEY = 'getConnectionById';

export const useConnectionInspectorQuery: UseQueryWrapper<
  ConnectionInspectorResult,
  GetConnectionByIdQueryVariables
> = ({ variables, options }) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  return useQuery<ConnectionInspectorResult>([QUERY_KEY, variables.connectionId], queryFn(variables), {
    onError,
    retry: false,
    enabled: !!variables.connectionId,
    ...(options || {}),
  });
};
